import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';
import { z } from 'zod';

enum OVERVIEW_MESSAGE {
  INTRODUCTION_EN = 'กรุณาระบุคำบรรยายเป็นภาษาอังกฤษ',
  REMARK_EN = 'กรุณาระบุหมายเหตุเป็นภาษาอังกฤษ',
}

export const OverviewSchema = z.object({
  introduction: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateEditorEn, {
        message: OVERVIEW_MESSAGE.INTRODUCTION_EN,
      })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  remark: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, {
        message: OVERVIEW_MESSAGE.REMARK_EN,
      })
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
});
